import { render, staticRenderFns } from "./SolutionSheetItemSpanRestraints.vue?vue&type=template&id=c1f519e8&"
import script from "./SolutionSheetItemSpanRestraints.vue?vue&type=script&lang=js&"
export * from "./SolutionSheetItemSpanRestraints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports